var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroesse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Groesse__Icn/40px/Groesse",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Groesse__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Groesse__Rectangle"
  })), /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Groesse__Icn/40px/Plus-Tools",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Groesse__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.9936309,8.67573771 L24.2362716,12.9183784 L23.1338921,13.9005497 L20.9999105,11.7667377 L20.9999105,27.1887377 L23.1338921,25.055936 L24.2362716,26.0381073 L19.9936309,30.280748 L15.7729105,26.0600276 L16.8307422,25.0021959 L18.9999105,27.1717377 L18.9999105,11.7837377 L16.8307422,13.9542898 L15.7729105,12.8964581 L19.9936309,8.67573771 Z",
    id: ".._.._src_svg_Icn_40px_Groesse__Combined-Shape-Copy",
    transform: "rotate(45 20.005 19.478)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroesse);
export default __webpack_public_path__ + "static/media/Groesse.9a5d3eb9c6abf7aa4ee00c8bc1ac5533.svg";
export { ForwardRef as ReactComponent };